<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :selectionEnabled="true"
      :actions="actions"
      ref="grid"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      :beforeSetupGrid="beforeSetupGrid"
    ></dx-grid>
    <v-dialog v-model="scheduleDownloadDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline">Schedule Download</v-card-title>
        <v-text-field
          ref="notificationEmail"
          v-model="notificationEmail"
          label="Notification Email"
          class="px-3"
          :rules="emailRules"
        ></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="scheduleDownloadDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="scheduleDownload"
          >
            download
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="changeClassDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-title class="text-warning headline">Change Class</v-card-title>
        <v-list>
          <template v-for="(student, index) in selectedStudents">
            <v-list-tile avatar ripple>
              <v-list-tile-content>
                <v-list-tile-title>{{ student.hName }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="index + 1 < selectedStudents.length"></v-divider>
          </template>
        </v-list>
        <v-card-actions>
          <v-select
            hide-details
            class="pr-2 ma-0"
            :items="classes"
            label="Class"
            v-model="newClass"
            box
            item-text="`${data.item.grade} - ${data.item.teacher}`"
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.grade }} -
              {{ data.item.teacher }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="`${data.item.grade} - ${data.item.teacher}`"
                >
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-select>
          <v-btn @click="changeClassDialog = false" color="default" dark
            >Cancel</v-btn
          >
          <v-btn
            :disabled="!newClass.classID"
            :loading="processing"
            color="success"
            @click="updateClass"
          >
            confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateBusDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline py-2 pb-3 px-2">Update Bus</v-card-title>
        <v-select
          ref="busNumber"
          v-model="busNumber"
          label="Bus Number"
          :items="buses.map((b) => b.value)"
          class="px-2 pt-0"
          clearable
        ></v-select>
        <v-btn
          class="mx-2 mt-0"
          small
          outline
          color="success"
          @click="openBusListDialog"
          >Add New Bus</v-btn
        >
        <v-card-actions class="mr-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="updateBusDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="saveBusNumber">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="busListDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 py-0">Bus List</v-card-title>

        <v-layout row class="ml-0">
          <v-btn small color="success" class="mb-3" @click="addBus"
            >Add Bus</v-btn
          >
          <v-btn
            small
            color="success"
            class="mb-3 ml-2"
            v-if="buses.some((l) => l.selected)"
            @click="deleteBuses"
            :loading="processing"
            >Delete Buses</v-btn
          >
        </v-layout>

        <div v-for="(bus, index) in newBuses">
          <v-layout row class="pa-0 ml-0 mb-0">
            <v-text-field
              class="mx-0"
              v-model="bus.value"
              label="Bus Number"
            ></v-text-field>

            <v-btn @click="addBus" flat icon color="success">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
            <v-btn @click="removeBus(index)" flat icon color="#f55a4e">
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </v-layout>
        </div>

        <v-btn
          color="success"
          outline
          class="ml-0 mt-0 mr-2 mb-4"
          :disabled="processing"
          @click="cancelAddingBuses"
          v-if="newBuses.length"
          style="height: 28px;"
          >Cancel</v-btn
        >
        <v-btn
          color="success"
          small
          class="ml-0 mt-0 mb-4"
          :loading="processing"
          @click="saveNewBuses"
          v-if="newBuses.length"
          >Save</v-btn
        >

        <v-divider class="pb-0 pt-1"></v-divider>
        <div style="height: 350px; overflow-y: auto;">
          <div v-for="(bus, index) in buses">
            <v-layout column class="pa-0 ml-0 mb-0">
              <v-layout row>
                <v-checkbox
                  class="width-50 pt-2 my-0"
                  hide-details
                  v-model="bus.selected"
                  v-if="!bus.editing"
                  color="success"
                ></v-checkbox>

                <div class="pt-2" v-if="!bus.editing">
                  {{ bus.value }}
                </div>
              </v-layout>
            </v-layout>
            <v-divider
              class="pb-0 pt-1 mt-2"
              v-if="index + 1 < buses.length"
            ></v-divider>
          </div>
        </div>
        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="busListDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { formatCurrency, onlyUnique } from "../utils/helpers.js";
import { loadOptions } from "../utils/smLookup.js";
import moment from "moment";
import Pusher from "pusher-js";
import axios from "axios";

export default {
  data: () => ({
    title: "Students",
    selectionEnabled: true,
    selectedStudents: [],
    processing: false,
    classes: [],
    changeClassDialog: false,
    updateBusDialog: false,
    busListDialog: false,
    newClass: {},
    countries: [],
    regID: "",
    notificationEmail: "",
    scheduleDownloadDialog: false,
    url: "",
    busNumber: "",
    buses: [],
    newBuses: [],

    emailRules: [
      (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    ],

    rules: {
      required: (value) => !!value || "Required",
    },

    columns: [
      {
        label: "Name",
        field: "name",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "father",
        label: "Father",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Name",
        field: "hName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Father Hebrew",
        field: "fatherH",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "First Name Hebrew",
        field: "firstNameH",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Name Hebrew",
        field: "lastNameH",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Gander",
        field: "gander",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Grade",
        field: "grade",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Class",
        field: "class",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Country",
        field: "country",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Bungalow",
        field: "bungalow",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Registration Type",
        field: "regType",
        format: "",
        visible: true,
        filterType: "",
        // filterValues: [],
        // filterValue: "NONE",
        // selectedFilterOperation: "<>",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Weeks",
        field: "weeks",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "date",
        label: "Date",
        type: "date",
        format: "",
        visible: false,
        filterType: "",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "dob",
        label: "DOB",
        type: "date",
        format: "",
        visible: false,
        filterType: "",
        format: "MM/dd/yyyy",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Card Printed",
        field: "cardPrinted",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: false,
      },
      {
        label: "Lunch Document",
        field: "lunchDoc",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: false,
      },
      {
        label: "Lunch Match Type",
        field: "lunchMatchType",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: true,
      },
      {
        label: "Lunch Case Num",
        field: "lunchCaseNum",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: false,
      },
      {
        label: "Lunch Match Record",
        field: "lunchMatchRecord",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: false,
      },
      {
        label: "Trip Money",
        field: "tripMoney",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: false,
      },
      {
        label: "Trip Amount",
        field: "tripAmount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        precision: 3,
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "cardPrintDate",
        label: "Card Print Date",
        type: "date",
        format: "",
        visible: false,
        filterType: "",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Immunizations",
        field: "lastImmunizationDocumentDescription",
        template: "link-action-cell-template",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Has Immunizations",
        field: "hasImmunizationRecords",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: false,
      },
      {
        label: "Non UTA",
        field: "nonUTA",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        visible: false,
      },
      {
        label: "Student ID",
        field: "studentID",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "accountID",
        label: "Account ID",
        link: "LapidusAccountView",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Home Phone",
        field: "homePhone",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Cellphone",
        field: "cellPhone",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mother Cell",
        field: "motherCell",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address",
        field: "address",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "ZipCode",
        field: "zipCode",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Bus Number",
        field: "busNumber",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Sort",
        field: "sort",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
    actions: [],
    pusher: {},
    requestID: "",
  }),
  async created() {
    this.actions.push({
      text: "Download Immunization Records",
      action: this.openScheduleDownloadDialog,
      showOnSelection: true,
    });

    this.actions.push({
      text: "Update Bus Number",
      action: this.openUpdateBusDialog,
      showOnSelection: true,
    });

    this.actions.push({
      text: "Update Class",
      action: this.openChangeClassDialog,
      showOnSelection: true,
    });

    this.actions.push({
      text: "Print Class List",
      action: this.printClassList,
    });

    // const downloadImmunizationAction = {
    //     text: "Download Immunization Records",
    //     name: "DownloadImmunizations",
    //     loading: false,
    //     showOnSelection: true,
    // };

    // downloadImmunizationAction.action = () =>
    //     this.downloadImmunizationRecords(
    //         downloadImmunizationAction.loading
    //     );

    // this.actions.push(downloadImmunizationAction);

    this.columns.find(
      (c) => c.field == "lastImmunizationDocumentDescription"
    ).linkAction = async (student) => {
      const url = await this.$http.get(
        "/api/lapidusDayCamp/GetImmunizationsDocument?filePath=" +
          student.lastImmunizationDocumentUrl
      );

      return window.open(url);
    };

    this.notificationEmail = this.$store.state.authentication.user;

    await this.loadCountries();

    this.loadBuses();

    this.subscribeToPusher();
  },
  beforeDestroy() {
    this.pusher.unsubscribe("lapidus-immunizations");
  },
  methods: {
    async beforeSetupGrid() {
      await this.loadRegID();

      this.loadClasses();

      const terms = await this.getTerms();

      terms.sort((a, b) => b.term.localeCompare(a.term));

      this.actions.push({
        text: "Select Term",
        type: "select",
        values: terms.map((t) => t.term),
        value: this.regID,
        onSelected: this.onTermSelected,
      });

      this.url = "lapidusStudents?regID=" + this.regID;
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
    },
    async getTerms() {
      return await this.$http.get("api/lapidusDayCamp/getRegTerms");
    },
    onTermSelected(value) {
      this.regID = value;

      this.url = "lapidusStudents?regID=" + this.regID;

      this.$refs.grid.reloadDataSource(this.url);
    },
    subscribeToPusher() {
      this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
        cluster: "mt1",
      });

      var channel = this.pusher.subscribe("lapidus-immunizations");

      this.pusher.connection.bind("error", function(err) {
        console.log(err);
      });

      channel.bind("download-immunizations", (message) => {
        this.updateImmunizationActionText(message);
      });
    },
    updateImmunizationActionText(message) {
      if (message.requestID != this.requestID) return;

      const action = this.actions.find(
        (a) => a.name == "DownloadImmunizations"
      );

      const splitted = action.text.split("Records ");

      const text = splitted[0];

      if (!text || !splitted[1]) return;

      const total = splitted[1].split("/")[1];

      const index = +message.index;

      action.text = text + "Records " + index + "/" + total;
    },
    openChangeClassDialog() {
      this.selectedStudents = this.$refs.grid.getSelectedRowsData();

      this.changeClassDialog = true;
    },
    openUpdateBusDialog() {
      this.selectedStudents = this.$refs.grid.getSelectedRowsData();

      this.updateBusDialog = true;
    },
    openBusListDialog() {
      this.busListDialog = true;
    },
    addBus() {
      const sort = this.buses.length + this.newBuses.length;

      this.newBuses.push({
        type: "LapidusBus",
        value: "",
        sortOrder: sort,
      });
    },
    cancelAddingBuses() {
      this.newBuses = [];
    },
    removeBus(index) {
      this.newBuses.splice(index, 1);
    },
    rollbackBus(bus) {
      bus.value = bus.original;
      bus.editing = false;

      this.$forceUpdate();
    },
    editBus(bus) {
      bus.original = bus.value;
      bus.editing = true;

      this.$forceUpdate();
    },
    async deleteBuses() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/lapidusDayCamp/deleteBusNumbers",
          this.buses.filter((b) => b.selected).map((l) => l.id)
        );

        this.processing = false;
        this.newBuses = [];

        this.loadBuses();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveNewBuses() {
      if (this.newBuses.some((b) => !b.value)) {
        return this.$notify({
          text: "Bus Number can't be empty",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        await this.$http.post(
          "api/lapidusDayCamp/addBusNumbers",
          this.newBuses.filter((b) => b.value)
        );

        this.processing = false;
        this.newBuses = [];

        this.loadBuses();
      } catch (e) {
        this.processing = false;
      }
    },
    async loadClasses() {
      const classes = await this.$http.get(
        "api/classSetup/get?regID=" + this.regID
      );

      this.classes = classes.filter((c) => {
        return c.regID.trim() == this.regID;
      });
    },
    async loadCountries() {
      this.countries = (await loadOptions("country")).map((c) => c.value);
    },
    async loadBuses() {
      this.buses = (await loadOptions("LapidusBus")).map((b) => {
        b.editing = false;
        b.selected = false;

        return b;
      });
    },
    async updateClass() {
      this.processing = true;

      const data = {
        students: this.selectedStudents.map((student) => ({
          studentID: student.studentID,
          classID: this.newClass.classID,
        })),
      };

      try {
        await this.$http.post(
          "api/lapidusDayCamp/UpdateClass?user=" +
            this.$store.state.authentication.user,
          data
        );
      } catch (e) {
        this.processing = false;

        return;
      }

      this.processing = false;

      this.newClass = {};

      this.changeClassDialog = false;
      this.selectedStudents = [];

      this.$refs.grid.reloadGrid();
    },
    async saveBusNumber() {
      //if (!this.$refs.busNumber.validate(true)) return;

      try {
        this.processing = true;

        await this.$http.post("api/lapidusDayCamp/updateBusNumber", {
          user: this.$store.state.authentication.user,
          busNumber: this.busNumber,
          dayCampIDs: this.selectedStudents.map((s) => s.dayCampID),
        });

        this.updateBusDialog = false;

        this.$refs.grid.reloadGrid();

        this.processing = false;
        this.busNumber = "";

        this.$notify({
          text: "Bus Number Saved",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        this.processing = false;
      }
    },
    openScheduleDownloadDialog() {
      this.scheduleDownloadDialog = true;
    },
    async scheduleDownload() {
      if (!this.$refs.notificationEmail.validate(true)) return;

      let students = this.$refs.grid.getSelectedRowsData();

      const columnSort = this.columns.find((c) => {
        const sort = this.$refs.grid.grid.columnOption(c.field, "sortOrder");

        if (!sort) return false;

        return true;
      });

      if (columnSort) {
        const sortOrder = this.$refs.grid.grid.columnOption(
          columnSort.field,
          "sortOrder"
        );

        students = students.sort((a, b) => {
          if (sortOrder == "desc") {
            if (a[columnSort.field] < b[columnSort.field]) {
              return 1;
            }
            if (a[columnSort.field] > b[columnSort.field]) {
              return -1;
            }
            return 0;
          } else {
            if (a[columnSort.field] < b[columnSort.field]) {
              return -1;
            }
            if (a[columnSort.field] > b[columnSort.field]) {
              return 1;
            }
            return 0;
          }
        });
      }

      let studentList = await this.$http.post(
        "api/lapidusDayCamp/GetStudentsForImunizations?",
        {
          students: students
            .filter((s) => s.lastImmunizationDocumentUrl)
            .map((student) => student.studentID),
          regID: this.regID,
        }
      );

      const studentIDOrder = students.map((s) => s.studentID.trim());
      studentList = studentList.sort(
        (a, b) =>
          studentIDOrder.indexOf(a.studentID.trim()) -
          studentIDOrder.indexOf(b.studentID.trim())
      );

      const immunizations = studentList.map((student) => student.studentID);

      if (!immunizations.length) {
        this.$notify({
          group: "notification",
          text: "No Immunizations Records for Filetered Students.",
          type: "warning",
        });

        return;
      }

      this.requestID = Math.floor(Math.random() * 10000000);

      try {
        this.processing = true;

        const response = await this.$http({
          url: "api/lapidusDayCamp/scheduleFileDownload",
          method: "POST",
          data: {
            students: immunizations,
            classList: this.createClassListHtml(studentList),
            requestID: this.requestID,
            regID: this.regID,
            email: this.notificationEmail,
            user: this.$store.state.authentication.user,
            date: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
          responseType: "blob",
        });

        this.$notify({
          group: "notification",
          text: this.notificationEmail
            ? "You will be notified once the file is ready to download"
            : "Check back later at the file downloas page to check for the status of your file",
          type: "success",
        });
        this.scheduleDownloadDialog = false;
      } catch (e) {
        console.log(e);
        this.processing = false;
      } finally {
        this.processing = false;

        this.requestID = "";
      }
    },
    async printClassList() {
      const students = this.$refs.grid.grid.getDataSource().items();

      if (!students.length) return;

      var myWindow = window.open("", "Class List", "width=1000, height=1200");

      myWindow.document.write(this.createClassListHtml(students));
    },
    createClassListHtml(students) {
      const showClass = students.some((s) => s.class != students[0].class);

      let html = `<head>
                        <style>
                        table {
                          font-family: arial, sans-serif;
                          border-collapse: collapse;
                          width: 100%;
                        }

                        .nice-text {
                            font-family: arial, sans-serif;
                        }

                        td, th {
                          border: 1px solid #dddddd;
                          text-align: left;
                          padding: 5px;
                          font-size: 11px;
                        }

                        tr:nth-child(even) {
                          background-color: #dddddd;
                        }

                        .right-align {
                text-align: right;
            }
                        </style>
                        </head>`;

      html += `<p class="nice-text right-align">${moment().format("LLL")}</p>`;

      const firstStudentClass = this.classes.find(
        (c) => c.classID == students[0].classID
      );

      const classTitle =
        firstStudentClass.grade + " - " + firstStudentClass.teacher;

      html += showClass
        ? `<h2 class="nice-text">Class List</h2>`
        : `<h2 class="nice-text">Class List - ${classTitle}</h2>`;

      html += `<table>
                            <tr>
                            <th>Name</th>
                            <th class="right-align">Hebrew Name</th>
                            <th class="right-align">Father</th>
                          `;

      if (showClass) {
        html += `<th>Class</th>`;
      }

      html += `
                            <th>Weeks</th>
                            <th>Country</th>
                            <th>Cell Phone</th>
                            <th>Mother Cell</th>`;

      html += "</tr>";

      students
        .map((student) => {
          let data = {
            name: student.name,
            hebName: student.hName,
            fatherH: student.fatherH,
          };

          if (showClass) {
            data.class = student.class;
          }

          data.weeks = student.weeks;
          data.country = student.country;
          data.cellPhone = student.cellPhone;
          data.motherCell = student.motherCell;

          return data;
        })
        .forEach((student) => {
          html += `<tr>`;

          Object.entries(student).forEach((v) => {
            const field = v[0];
            const value = v[1];

            html += ["hebName", "fatherH"].includes(field)
              ? `<td class="right-align">${value}</td>`
              : `<td>${value ? value : ""}</td>`;
          });

          html += `</tr>`;
        });

      html += `</table>`;

      console.log(html);

      return html;
    },
    onRowClicked(student) {
      this.$router.push({
        name: "LapidusAccountView",
        params: {
          id: student.accountID,
        },
        query: {
          studentID: student.studentID,
          isGirls: student.gander == "GIRLS",
        },
      });
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
.v-btn__content {
  color: unset;
}
</style>
